<template>
  <component :is="as"
             :class="{ 'drag-in-progress': !disabled && dragOverComponentInProgress,
                       'info': variant === 'info',
             }"
             v-bind="$attrs"
             @dragover="dragover"
             @dragenter="dragEnter"
             @dragleave="dragLeave"
             @drop.prevent="drop"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'AppDroppableArea',
  emits: ['dragenter', 'dragleave', 'ondrop'],
  props: {
    as: {
      type: [String, Object],
      default: 'div',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      required: false,
    },
  },
  data () {
    return {
      childComponentsEntered: 0,
    }
  },
  computed: {
    dragOverComponentInProgress () {
      return this.childComponentsEntered > 0
    },
  },
  watch: {
    dragOverComponentInProgress (value, previousValue) {
      if (!previousValue && value) {
        this.$emit('dragenter')
      }

      if (previousValue && !value) {
        this.$emit('dragleave')
      }
    },
  },
  methods: {
    dragover (event) {
      if (!this.disabled) {
        event.preventDefault()
      }
    },
    dragEnter () {
      this.childComponentsEntered += 1
    },
    dragLeave () {
      this.childComponentsEntered -= 1
    },
    drop ($event) {
      this.childComponentsEntered = 0

      if (!this.disabled) {
        this.$emit('ondrop', $event)
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .drag-in-progress {
    transition: all .1s ease-in-out;
    background-color: rgb(var(--v-theme-surface-info)) !important;
    outline: 2px dashed rgb(var(--v-theme-border-info-bold));
    outline-offset: -2px;

    &.info {
      border-radius: 8px;
      outline: 1px solid rgb(var(--v-theme-border-info-bold));
      outline-offset: -1px;
      background-color: rgb(var(--v-theme-surface-info)) !important;
      overflow: hidden;
    }
  }
</style>
